<template>
  
  <v-dialog value="true" persistent max-width="560px">
      <v-card>
        <v-card-title class="justify-center secondary">Adresse technique</v-card-title>
        <v-card-text>
          <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
      >
    <v-radio-group v-model="adrTech"  :rules="[v => !!v || 'Item is required']" required>
      <v-radio class="radio-size"
        v-for="(logement, index) in ftthService.logements"
        :label="`Batiment : ${logement.batiment} | Escalier : ${logement.escalier} | Etage : ${logement.etage}`"
        :key="index"
        :value="logement"
      ></v-radio>
    </v-radio-group>
    <v-card-actions>
      <v-btn @click="$emit('closeDialogAdrTech')">Annuler</v-btn>
     <v-spacer></v-spacer>
     <v-btn @click="addAdrTech" color="primary" :disabled="!valid" :loading="loading"
      class="white--text"
     >Valider</v-btn>
   </v-card-actions>
     </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

export default {
 name:"AdrTech",
 props: ['ftthService'],
  data () {
    return {  
      loading:false,
      valid: true,
      adrTech : null,
      
    lazy: false,
    }
  },
  mounted() {
    this.init();
    
  },
  methods: {
    init: function(){
    },
    addAdrTech: function(){
      this.loading = true;
        this.$emit("addAdrTech", this.adrTech, () => { this.loading = false; });
      }
  }
}
</script>
<style scoped>
.radio-size{
    font-size:15px !important;
}
 .v-card__title{
   color: white;
} 
</style>
